import { Radio, RadioChangeEvent } from "antd";
import { RadioRules } from "../../types/field";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

interface Props {
  options: Array<any>;
  title?: string;
  placeholder: string;
  onChange?: any;
  disabled?: boolean;
  value?: any;
  className?: string;
  rules?: RadioRules;
  control: any;
  name: string;
  api: string;
  data?: any;
  setValue: any;
  uiType?: string;
}

const CommonRadioGroup: React.FC<Props> = ({
  onChange,
  disabled,
  options,
  data,
  uiType = "radio"
}) => {

  const [selected, setSelected] = useState<string>(data || "");
  const { t } = useTranslation();

  useEffect(() => {
    setSelected(data || "");
  }, [data]);

  const handleChange = (str: any) => {

    setSelected(str);
    if(str !== selected) {
      onChange(str);
    }
    
  }

  const handleClick = () => {
    onChange("");
    setSelected("");
  }

  return (

    <>
      <Radio.Group disabled={disabled} onChange={(e: RadioChangeEvent) => { handleChange(e.target?.value) }}
        value={selected}>
        {options.map((item: any, idx: number) => (
          <Radio disabled={disabled} onClick={(e) => { e.preventDefault(); e.stopPropagation(); (selected === item?.radioValue && uiType === "checkBox") ? handleClick() : console.log("");  }} key={idx} value={item?.radioValue}>
            <span className="font-medium"> {t(item?.radioValue)}</span>
          </Radio>
        ))}
      </Radio.Group>

    </>

  );
};

export default CommonRadioGroup;